export const AVP_METERING_POINTS_FETCH =
  'MANUAL_ISSUING_AVP_METERING_POINTS_FETCH';
export const REFRESH_MEASUREMENT_DATA =
  'MANUAL_ISSUING_REFRESH_MEASUREMENT_DATA';
export const CALCULATE_MEASUREMENT_DATA =
  'MANUAL_ISSUING_CALCULATE_MEASUREMENT_DATA';
